export interface Breadcrumb {
  text: string
  href: string
}

export interface Factoid {
  description: string
  image: string
  title: string
  url: string
}

export interface LoadState<T, U = Error> {
  isLoading: boolean
  data: T
  isLoaded: boolean
  error: U | null
}

export interface Seo {
  title: string | undefined
  description: string | undefined
  keywords: string | undefined
  seo_title?: string | undefined
  seo_description?: string | undefined
  seo_keywords?: string | undefined
}

export enum Mode {
  DEVELOPMENT = 'dev',
  STAGING = 'staging',
  BRANCH = 'branch',
  RELEASE = 'release',
  RC = 'rc',
}

/**
 * Перечисление соц. сетей для яндекс метрики
 */
export type SocialNetworkTypes = 'vkontakte' | 'odnoklassniki' | 'telegram'

export enum AsyncDataKey {
  SIMLE_CATEGORIES = 'simpleCategories',
}
